import React, { useCallback, useEffect, useState } from "react";
import "./PostPaymet.css";
import InputField from "../../../../../newComponents/form-fields/InputField";
import H5 from "../../../../../newComponents/typography/H5";
import SelectField from "../../../../../newComponents/form-fields/SelectField";
import apiHelper from "../../../../../utils/apiHelper";
import { PaymentService } from "@propertelligent/client-api";
import { useForm, FormProvider } from "react-hook-form";
import { NotificationType, PubSub, TopicsEnum } from "../../../../../utils/pubsub";
import SimpleButton from "../../../../../newComponents/buttons/Simple-button";
import AddTraspButton from "../../../../firstTimeUserExperience/commonCom/AddTraspButton";
import UtilHelper from "../../../../../utils/UtilHelper";
import { TextCss } from "../../../../GlobalCss/TextCss";
import TenantTabContent from "../../../../../newComponents/tabs/tabs/tab-pages/tenant-tab-content";
import CurrencyTooltip from "../../../../currencytooltip/CurrencyTooltip";

const PostPayment = ({ data, tenantId, setShowModel, payDueAccountId,feestype=undefined }) => {
  const methods = useForm();
  const { handleSubmit } = methods;
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentDetail,setPaymentDetails] =useState()
  const [duesToSettle, setDuesToSettle] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>(null);

  const handlePaymentMethodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const method =
      paymentMethods?.find((x) => x.id === Number(e.target.value))?.accountName ||
      "";
    setSelectedPaymentMethod(method);
  };

  const paymentMethodOptions = paymentMethods?.map((method) => ({
    Id: method.id,
    Name: method.accountName,
  }));

   const fetchInitialData = useCallback(async () => {
      // setIsLoading(true);
      try {
        const [paymentMethod, paymentDetail] = await Promise.all([
          apiHelper(
            PaymentService.getApiPaymentMethodTenantlist,
            { showNotification: false },
            tenantId
          ),
          apiHelper(
            PaymentService.getApiPaymentDueAccountReceivable,
            { showNotification: false },
            tenantId
          ),
        ]);
     
   setPaymentMethods( paymentMethod?.data?.success);
   setPaymentDetails(paymentDetail?.data?.success)
      } catch (error) {
        PubSub.publish(TopicsEnum.Notification.toString(), {
          message: "Failed to load required data",
          type: NotificationType.Failure,
        });
      } finally {
        // setIsLoading(false);
      }
    }, [tenantId ]);
     const fetchPaymentTenantlist = async () => {
  const res = await apiHelper(
    PaymentService.getApiPaymentDueAccountTenantlist,
    { showNotification: false },
    tenantId
  );

  return res?.data?.success || [];
};

  useEffect(() => {
    fetchInitialData();
    fetchPaymentTenantlist()
  }, [fetchInitialData]);

//  useEffect(() => {
//   fetchPaymentTenantlist().then((list) => {
//     const normalizedIds = Array.isArray(payDueAccountId)
//       ? payDueAccountId.map(id => Number(id))
//       : [];

//     const filtered = list.filter(due =>
//       normalizedIds.includes(Number(due.id))
//     );

//     setDuesToSettle(filtered);
//   });
// }, [payDueAccountId]);
 useEffect(() => {
  if (!Array.isArray(payDueAccountId) || payDueAccountId.length === 0) {
    setDuesToSettle([]);
    return;
  }

  fetchPaymentTenantlist().then((list) => {
   
    const normalizedIds = payDueAccountId.map(id => Number(id));
    const filtered = list.filter(due =>
      normalizedIds.includes(Number(due.id))
    );
    setDuesToSettle(filtered);
  });
}, [payDueAccountId]);
const onSubmit = async (formData) => {
  if (!duesToSettle.length) {
    PubSub.publish(TopicsEnum.Notification.toString(), {
      message: "No dues found to settle",
      type: NotificationType.Warning,
    });
    return;
  }

  const transactionId =
    formData?.transactionId ||
    crypto.randomUUID().replaceAll("-", "").toUpperCase();

  try {
    const paymentPromises = duesToSettle.map((due) => {
      const payload = {
        payDueAccountId: Number(due.id),
        amount: Number(due.amount),
        fromPaymentMethodId: Number(formData.PaymentModeId),
        paymentDate: new Date(formData.date).toISOString(),
        transactionId,
        checkNumber: formData?.checkNum,
      };

      const paymentMethod = paymentMethods.find(
        x => x.id === Number(formData.PaymentModeId)
      )?.accountName;

      if (paymentMethod !== "Check" && paymentMethod !== "Cash") {
        delete payload.checkNumber;
      }

      return apiHelper(
        PaymentService.putApiPaymentDueAccountPay,
        {
          successMessage: "Payment settled successfully",
          failureMessage: "Unable to settle payment",
          showNotification: true,
        },
        payload
      );
    });

    await Promise.all(paymentPromises);

    PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
    setShowModel(false);
  } catch (error) {
    PubSub.publish(TopicsEnum.Notification.toString(), {
      message: "Failed to settle payments",
      type: NotificationType.Failure,
    });
  }
};


useEffect(() => {
  const total = duesToSettle.reduce(
    (sum, due) => sum + Number(due.amount || 0),
    0
  );
  setTotalAmount(total);
}, [duesToSettle]);
  return (
    <div className="post-payment-container">
      
        <div className="payment-card justify-content-between">
          <div className="d-flex gap-3">
          <div className="tenant-avatar">
            <div className="tenant-initials">{UtilHelper.getInitials(data?.firstName + " " + data?.lastName)}</div>
          </div>
          <div className="">
            <p className={TextCss.black.heading_700_16}>{data?.fullName}</p>
            <p className={TextCss.grey_neutral.sub_heading_400_14}>{feestype}</p>
          </div>
          </div>
          <div className={` ${TextCss.black.main_heading_700_20}`}>
              <CurrencyTooltip 
                formatted={totalAmount}
                content={totalAmount}
              >
                  <span>{totalAmount}</span>
                </CurrencyTooltip>
            </div>
        </div>
        {/* <div className="post-payment-form"> */}
        <FormProvider {...methods}>
          <form className="payment-form" onSubmit={handleSubmit(onSubmit)}>
            <div className=" p-3 post-payment-form">
              <div className="payment-form-finput d-flex gap-4 ">
                <SelectField
                  placeholderText="Select Payment Mode"
                  name="PaymentModeId"
                  label="Payment Mode"
                  required
                  requiredMessage="Select Payment Mode is required"
                  options={paymentMethodOptions || []}
                  onChange={handlePaymentMethodChange}
                />
                <InputField
                  name="date"
                  label="Payment Date"
                  type="date"
                  required
                  requiredMessage="Payment Date is required"
                />
              </div>
              {selectedPaymentMethod === "Check" ? (
                <div className="col-md-6 mb-1">
                  <InputField
                    name="checkNum"
                    label="Check No"
                    type="text"
                    required
                    requiredMessage="Check No is required"
                  />
                </div>
              ) : (
                selectedPaymentMethod && selectedPaymentMethod !== "Cash" && (
                  <div className="col-md-6 mb-1">
                    <InputField
                      name="transactionId"
                      label="Transaction ID"
                      type="text"
                      required
                      requiredMessage="Transaction ID is required"
                    />
                  </div>
                )
              )}
            </div>

            <div className="form-actions-footer">
              <AddTraspButton bname="Cancel" border={false} onClick={() => setShowModel(false)} type="button" />
              <SimpleButton type="submit" label={"Post Payment"} />
            </div>
          </form>
        </FormProvider>
      {/* </div> */}
    </div>
  );
};

export default PostPayment;


